import { addDays, addMonths, type ProjectionInputData, type TenantSettings } from '@dairy/shared';

/** Settings-dependent IP-2 hard errors, shared by server and offline callers. */
export function projectionInputErrors(input: ProjectionInputData, settings: TenantSettings): string[] {
  const errors: string[] = [];
  const boundary = addMonths(input.birthDate, settings.calfMaxAgeMonths);
  if (input.kind === 'CALF' && input.startDate >= boundary) errors.push('kind');
  if (input.kind === 'HEIFER' && input.startDate < boundary) errors.push('kind');
  const service = input.serviceDate ?? (input.monthsPregnant === undefined ? undefined : addDays(input.startDate, -30 * input.monthsPregnant));
  if (service && addDays(service, settings.gestationDays) <= input.startDate) errors.push('serviceDate');
  return errors;
}
